// Libs
import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux'

// Reducers
import { reducer as reduxForm } from 'redux-form'
import alertReducer from './containers/Alert/reducer'
import appReducer from './containers/App/reducer'
import authReducer from './containers/Auth/reducer'
import captureReducer from './containers/Capture/reducer'
import clickSignReducer from './containers/ClickSign/reducer'
import filterPanelReducer from './containers/FilterPanel/reducer'
import dashboardReducer from './containers/Dashboard/reducer'
import driveReducer from './containers/Drive/reducer'
import headerReducer from './containers/Header/reducer'
import importerReducer from './containers/Importer/reducer'
import importerLawyerReducer from './containers/ImporterLawyer/reducer'
import mediatorReducer from './containers/Mediator/reducer'
import newInvitationPageReducer from './containers/NewInvitationPage/reducer'
import myCasesPageReducer from './containers/MyCasesPage/reducer'
import notifyReducer from './containers/Notify/reducer'
import onboardingReducer from './containers/Onboarding/reducer'
import paymentReducer from './containers/PaymentPage/reducer'
import popUpReducer from './containers/PopUp/reducer'
import searchReducer from './containers/Search/reducer'
import spCasePageReducer from './containers/SpCasePage/reducer'
import swapReducer from './containers/Swap/reducer'
import swapCaseReducer from './containers/SwapCase/reducer'
import featureReducer from './containers/Feature/reducer'

const rootReducer = combineReducers({
  routing: routerReducer,
  form: reduxForm,
  alert: alertReducer,
  app: appReducer,
  auth: authReducer,
  capture: captureReducer,
  clickSign: clickSignReducer,
  filterPanel: filterPanelReducer,
  dashboard: dashboardReducer,
  drive: driveReducer,
  header: headerReducer,
  importer: importerReducer,
  importerLawyer: importerLawyerReducer,
  mediator: mediatorReducer,
  newInvitationPage: newInvitationPageReducer,
  myCasesPage: myCasesPageReducer,
  notify: notifyReducer,
  onboarding: onboardingReducer,
  payment: paymentReducer,
  popUp: popUpReducer,
  search: searchReducer,
  spCasePage: spCasePageReducer,
  swap: swapReducer,
  swapCase: swapCaseReducer,
  feature: featureReducer
});

export default rootReducer;
